module.exports = __webpack_public_path__ + "img/I2.22d81ce2.png";